import { useEffect, useState } from 'react';
import { Button, Col, Form, Input, message, PageHeader, Row, Spin } from 'antd';
import Helmet from 'react-helmet';

import ClientsService from './ClientsService';
import styles from './clienteditpage.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import ImageKitDirectUpload from '../../components/ImageKitDirectUpload';

type RouteParams = {
    client?: string;
};

const ClientEditPage = () => {
    const { client: clientSlug } = useParams() as RouteParams;
    const title = clientSlug ? 'Editar cliente' : 'Nuevo cliente';
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const returnPage = '/admin/evals';

    const [loading, setLoading] = useState(false);

    const saveChanges = (data: any) => {
        try {
            setLoading(true);
            if (data.website && !data.website.startsWith('http'))
                data.website = `https://${data.website}`;

            if (clientSlug) {
                ClientsService.updateClient(clientSlug, data);
            } else {
                ClientsService.createClient(data);
            }
            message.success('Se guardaron los cambios');
            navigate(returnPage);
        } catch (err) {
            setLoading(false);
            message.error((err as Error).message);
        }
    };

    useEffect(() => {
        if (!clientSlug) return;

        const fetchClient = async () => {
            try {
                setLoading(true);
                const data = await ClientsService.getClientDetails(clientSlug);
                if ((data.website ?? '').startsWith('http'))
                    data.website = data.website
                        .replace('http://', '')
                        .replace('https://', '');
                form.setFieldsValue(data);
                setLoading(false);
            } catch (err) {
                message.error((err as Error).message);
                setLoading(false);
            }
        };

        fetchClient();
    }, [clientSlug, form]);

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <PageHeader
                onBack={() => navigate(returnPage)}
                title={title}
            ></PageHeader>
            <Spin spinning={loading}>
                <Form
                    className={styles.form}
                    layout="vertical"
                    form={form}
                    requiredMark="optional"
                    onFinish={saveChanges}
                >
                    <Row gutter={[16, 16]} style={{ alignItems: 'center' }}>
                        <Col span={12}>
                            <Form.Item
                                label="Nombre (Razón social)"
                                name="name"
                                rules={[{ required: true }]}
                            >
                                <Input placeholder="Ej: Comunicaciones Alianza" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Página web"
                                name="website"
                                rules={[
                                    {
                                        type: 'url',
                                        transform: (val) => `https://${val}`,
                                        message: 'Debe ser una URL válida',
                                    },
                                ]}
                            >
                                <Input
                                    addonBefore="https://"
                                    placeholder="Ej: www.comunicacionesalianza.com"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label="Logo" name="logo">
                                <ImageKitDirectUpload />
                            </Form.Item>
                        </Col>
                    </Row>
                    <div className={styles.buttons}>
                        <Button href={returnPage}>Cancelar</Button>
                        <Button type="primary" htmlType="submit">
                            Guardar
                        </Button>
                    </div>
                </Form>
            </Spin>
        </>
    );
};

export default ClientEditPage;
